import { signal } from "@angular/core";
import { SearchState } from "src/app/models/search-model";

export const paginationState = signal<SearchState|undefined>(undefined);